import axios from 'axios';

const getGrupos = (params) => axios.get('/fornecedor/grupos-compras', { params });

export default {
  getGrupos,
};
